class VBFLocalization extends HTMLElement {
  constructor () {
    super()

    this.elements = {
      details: this.querySelector('details'),
      summary: this.querySelector('summary'),
    }

    this.elements.summary.addEventListener('click', this.onSummaryClick.bind(this))
    this.elements.details.addEventListener('keyup', this.onDetailsKeyUp.bind(this))
  }

  onDetailsKeyUp (event) {
    return event.code.toUpperCase() === 'ESCAPE' && this.close()
  }

  onBodyClick (event) {
    if (!this.contains(event.target)) {
      return this.close()
    }
  }

  onSummaryClick (event) {
    event.preventDefault()

    this.elements.details.hasAttribute('open') ? this.close() : this.open()
  }

  open () {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this)

    this.elements.details.setAttribute('open', true)
    document.body.addEventListener('click', this.onBodyClickEvent)
  }

  close () {
    this.elements.details.removeAttribute('open')
    document.body.removeEventListener('click', this.onBodyClickEvent)
  }
}

customElements.define('vbf-localization', VBFLocalization)
